import { render, staticRenderFns } from "./form.item.vue?vue&type=template&id=a75dc678&"
import script from "./form.item.vue?vue&type=script&lang=ts&"
export * from "./form.item.vue?vue&type=script&lang=ts&"
import style0 from "./form.item.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports